/**
 * LearnPress Exams frontend entry point.
 */

import '../loadAJAX.js';
import { ExamArchive } from 'lpExamsAssetsJsPath/frontend/exams/exam-archive.js';
import { SingleExam } from 'lpExamsAssetsJsPath/frontend/exams/single-exam.js';
import { ExamWorkspace } from 'lpExamsAssetsJsPath/frontend/exams/exam-workspace.js';
import { ExamResult } from 'lpExamsAssetsJsPath/frontend/exams/exam-result.js';

document.addEventListener( 'DOMContentLoaded', () => {
	new ExamArchive();
	new SingleExam();
	new ExamWorkspace();
	new ExamResult();
} );
